import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      minHeight: `unset !important`,

      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },
  '& .checkout_stripe_payment': {
    '& .promo-spinner': {
      backgroundColor: 'unset',
    },
  },

  '.headerHighlight': {
    color: palette.text.header
  },

  '.urbndental-container': {
    '& .savings-hero-section, .checkout-hero-section, .faq-hero-section, .dashboard-hero-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
      {
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center',
        background: palette.background.header,
        '& .hero-header-title, & .hero-header-subtitle': { 
          color: palette.text.highlight,
        },
        '& .hero-header-title': {
          fontWeight: 600
        }
      },
    '@media(max-width: 900px)': {
      '& .header-wrapper': {
        paddingBottom: '10px',
      },
    },

    '& .find-provider-section, .plan-selection-section': {
      display: 'flex',
      justifyContent: 'center',
      textAlign: 'center',
      background: palette.background.header,
      height: 420,
      '& .hero-header-title, & .hero-header-subtitle': { 
        color: palette.text.highlight,
      },
      '& .hero-header-title': {
        fontWeight: 600
      },
      '@media(max-width: 900px)': {
        height: 360,
      }
    },
    
    '& .checkout-outer-container, .plan-selection-container': {
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      background: palette.background.tertiary,
      '& .hero-section-alternate': {
        height: 'auto !important',
        paddingBottom: 0,
        
        '& .hero-title': {
          fontSize: 42,
          fontWeight: 600,
          lineHeight: '55px',

          '@media(min-width: 678px)': {
            fontSize: 48,
            lineHeight: '60px',
          },

          '@media(min-width: 900px)': {
            fontSize: 58,
            lineHeight: '80px',
            letterSpacing: '-0.04em',
          },
          '@media(max-width: 768px)': {
            maxWidth: 280,
          },
          '@media (min-width: 768px) and (max-width: 1023px)': {
            maxWidth: 'none',
            textAlign: 'left',
          },
          '@media (min-width: 1024px) and (max-width: 1366)': {
            color: 'red'
          }
        },
        '& .hero-subtitle': {
          fontWeight: 400,
          fontSize: 16,
          lineHeight: '30px',
          maxWidth: 600,
          '@media(min-width: 767px)': {
            fontSize: 18,
          },
          '@media (min-width: 768px) and (max-width: 1024px)': {
            maxWidth: 'none',
            textAlign: 'left',
          }
        },
      },
      '& .section-header__title-wrapper': {
        '@media(max-width: 900px)': {
          display: 'flex',
          justifyContent: 'center',
        },
      },
      '& .image-wrapper': {
        '& .image': {
          boxShadow: 'none',
          height: 'auto',
        },
        '@media(max-width: 900px)': {
          display: 'none',
        },
      },
      '@media(min-width: 900px)': {
        '& .section-alternate__content': {
          paddingTop: 34,
        },
        maxHeight: '740px',
      },
      '@media(max-width: 900px)': {
        '& .hero-title, .hero-subtitle': {
          textAlign: 'center',
        },
        '& .section-header__cta-wrapper': {
          '& .section-header__cta-container': {
            '& .section-header__cta-item-wrapper': {
              width: '100%',
              '@media (min-width: 768px) and (max-width: 1024px)': {
                display: 'flex',
              }
          }
          }
        }
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      '& .definition-variant-3': {
        '& .benefits-wrapper': {
          '& .definition-service-title': {
            fontSize: 20,
          },
          '& .definition-service-description': {
            fontSize: 16,
            fontWeight: 400,
            color: palette.text.light,
  
            '@media(min-width: 900px)': {
              maxWidth: 350,
            },
          },
        },
        '& .section-header__title': {
          marginBottom: 32
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      background: palette.background.main,
      '& .section-header__title, .subscription-tabs-label, .summary-text, .summary-subtext': {
        color: palette.text.highlight,
      },
      '& .subscription-bg': {
        backgroundColor: palette.background.main,
      },
      '& .section-header__subtitle-wrapper': {
        display: 'flex',
        justifyContent: 'center',
        '& .section-header__subtitle': {
          color: palette.text.highlight,
          maxWidth: '680px',
        },
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          border: 'none',
          '&:hover': {
            border: `1px solid ${palette.primary.alternate}`,
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .price-value': {
            color: palette.text.primary,
            fontWeight: 'bold',
          },
        },
        '& .savings-summary-link': {
          textDecoration: 'underline',
          color: palette.text.link,
          cursor: 'pointer',
        },
        '& .MuiSwitch-root': {
          '& .MuiIconButton-root': {
            color: palette.secondary.main,
          },
          '& .MuiSwitch-track': {
            backgroundColor: palette.text.highlight,
            borer: 'none'
          }
        }
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,
      '& .section': {
        paddingBottom: '34px'
      },
      '& .howitworks-title': {
        marginBottom: 56,
      },
      '& .section-header__title-wrapper': {
        '& .section-header__title': {
          textAlign: 'center',
        }
      },
      '& .howitworks-subtitle': {
        textAlign: 'center',
      },
      '& .section-header__subtitle-wrapper': {
        fontSize: 18,
        fontWeight: 400,
        '& .section-header__subtitle': {
          color: palette.text.light,
          textAlign: 'center',
        }
      },
      '& .how-it-works-image': {
        height: 'auto',
        width: 'auto',
      },
      '& .step-content': {
        maxWidth: 400,
        color: palette.text.light,
        fontSize: 16,
        fontWeight: 400,
        letterSpacing: '-0.02em',
      },
      '& .working-steps-container': {
        textAlign: 'center',
        paddingBottom: 24,
        marginBottom: 8,

        '& .step-counter': {
          borderRadius: '36px',
          backgroundColor: palette.background.header,
          color: palette.text.primary,
        },
        '& .step-title-wrapper': {
          '& .step-title': {
            fontSize: 24,
            fontWeight: 500,
            letterSpacing: '-0.01em',
          },
        },
        '& .step-content-wrapper': {
          paddingTop: 0 
        }
      },
      '@media (min-width: 768px) and (max-width: 1024px)': {
        '& .step-title-wrapper': {
          paddingBottom: 0,
          '& .step-title': {
            fontSize: '18px !important',
           }
        },
        '& .step-subtitle-wrapper': {
          display: 'flex',
          justifyContent: 'center',
        },
        '& .howitworks-wrapper': {
          padding: 0
        },
         '& .working-steps-container': {
          textAlign: 'center',
         },
      },
      '@media(min-width: 900px)': {
        '& .howitworks-wrapper-left': {
          paddingRight: 80,
        },
      },
      '@media(max-width: 900px)': {
          display: 'none',
      }
    },
    

    /* Freebie - Styles */
    '& .freebie-container': {
      '& .freebie-hero-image-grid': {
        "@media(min-width: 1727px)": {
          minHeight: 560
        },
        "@media(max-width: 900px)": {
          background: palette.background.main,
        }
      }
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .section-header': {
        '& .section-header__title': {
          color: palette.text.primary,
        },
        '& .section-header__subtitle': {
          color: palette.text.primary,
        },
      },
      '& .service-plan-table': {
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .footer-bar': {
        backgroundColor: palette.background.primary,

        '& .footer-bar-text': {
          color: palette.text.highlight,
        },
      },
      '& .savings-contact-card': {
        padding: '0px 60px !important',
        background: palette.background.footer,
      },
    },

    //Stepper Style
    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        display: 'none',
      }
    },

    '& .stepperItems': {
      marginTop: 24,
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .section-alternate__content': {
        paddingTop: 64,
        paddingBottom: 64
      },
      '& .hero-static-title': {
        fontWeight: 'bold',
        letterSpacing: '-0.04em',
      },
      '& .hero-static-subtitle': {
        color: palette.text.secondary,
      },
      '& .hero-static-bg': {
        backgroundColor: palette.background.tertiary,
      },
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .planCard': {
        borderColor: palette.primary.alternate,
        '&:hover': {
          color: palette.text.primary,
          backgroundColor: palette.text.highlight,
          '& .highlight-divider': {
            background: palette.divider,
          },
        },
      },
      '& .primary-static-button': {
        backgroundColor: palette.primary.alternate,
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
        background: palette.background.filter
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        background: palette.background.light,
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
      '& .logo-wrapper': {
        borderColor: 'rgba(42, 90, 117, 0.20)',
        background: palette.text.highlight,
        '@media(max-width: 900px)': {
          display: 'none',
        }
      },
      '& .details-root': {
        display: 'none',
      }
    },

    '& .plan-selection-container': {
      '& .section-header__title, .description-cta__subtitle, .titleDivider': {
        display: 'none'
      },
      '& .hero-static-title': {
        display: 'block'
      },
      '& .section': {
        paddingTop: 0
      },
      '& .filter-container': {
        top: '292px',
        '& .provider-details': {
          width: '100%'
        },
      },
      '@media(max-width: 900px)': {
        '& .filter-container': {
          top: '300px',
        },
        '& .plans-wrapper': {
          marginTop: 76
        },
        '& .provider-details': {
          padding: 10,
          '& .address-mobile-wrapper': {
            paddingTop: 0,
            paddingBottom: 0
          }
        },
        '& .section': {
          padding: 0
        },
        '& .switch-box': {
          marginBottom: 0,
        },
      },
      '@media(min-width: 900px)': {
        '& .switch-box': {
          justifyContent: 'end',
        },
      }
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .hero-header-title, & .hero-header-subtitle': {
        textAlign: 'center',
      },
      '& .hero-link-button': {
        background: palette.text.highlight,
        color: palette.text.primary,
      },
      '& .MuiButton-outlined': {
        border: `1px solid ${palette.text.primary}`,
        background: palette.primary.alternate,
        color: palette.text.highlight,
        borderColor: palette.text.highlight,
      }
    },
    '& .faqInnerContainer': {
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
      },
    },
    '& .faq-contact-section': {
      '& .contact-card-subtitle': {
        color: palette.text.secondary,
        fontSize: 20,
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.background.footer,
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
        padding: 0,
        marginRight: 8,
      },
      '& .provider-contact-details': {
        fontSize: 18,
        fontWeight: 400,
      },
      '& .provider-contact-link': {
        fontSize: 24,
        fontWeight: 500,
      },
    },

    /* Subscription Success Page */
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
    },

    /* Footer style */
    '& .footer-wrapper': {
      background: palette.text.highlight,
      borderTop: `1px solid ${palette.divider}`,
    },
  },
};
